import CurrencyDetail from './CurrencyDetail';

export default CurrencyDetail;



// WEBPACK FOOTER //
// ./src/scenes/Currencies/CurrencyDetail/index.ts